import React from 'react';
import EmElaboracao from './EmElaboracao';

export default function GestaoSolicitacaoRemocao() {
  return (
    <EmElaboracao
      title="Gestão de Solicitação de Remoção"
      description="Registro e acompanhamento de solicitações de remoção de pacientes."
      icon="🚑"
      section="Homecare"
    />
  );
}
